import * as React from 'react'
import { Theme } from '@mui/material/styles'
import { FC } from 'react'
import { ContactCard, CardVariants } from '../ContactCard'
import { ENTITY_TYPES } from '@sales-center/common'
import { LocationOrContact } from '../hooks/useCleanupEntityContacts'
import { IMoreMenuItem } from '@sales-center/components'
import Box from '@mui/material/Box'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  canUpdateEntity: boolean
  primaryContactId: number
  items: LocationOrContact[]
  variant: CardVariants
  getMenuItems: (
    item: LocationOrContact,
    variant: CardVariants,
  ) => IMoreMenuItem[] | undefined
}

const styles = {
  noContacts: {
    color: (theme: Theme) => theme.palette.text.primary,
    fontSize: '16px',
  },
}

export const ContactsList: FC<Props> = (props) => {
  const { items, primaryContactId, getMenuItems, variant } = props

  return (
    <Box>
      {!items || items.length === 0 ? (
        <Box sx={styles.noContacts}>No additional contacts added</Box>
      ) : (
        <Box sx={styles.noContacts}>
          {items.map((item) => (
            <ContactCard
              {...props}
              key={item.data.contact.id}
              contact={item.data.contact}
              isPrimaryContact={item.data.contact.id === primaryContactId}
              maxWidth="1000px"
              locationType={
                item.type === 'location'
                  ? item.isBillToAndService
                    ? 'both'
                    : item.data.billingLocation
                    ? 'billto'
                    : 'service'
                  : undefined
              }
              menuOptions={getMenuItems(item, variant)}
            />
          ))}
        </Box>
      )}
    </Box>
  )
}
ContactsList.displayName = 'ContactsList'
